import { Type } from "../Type";
export function any(name) {
    return new IslyAny(name ?? "any");
}
export class IslyAny extends Type {
    class = "any";
    is = (value) => value != undefined;
}
//# sourceMappingURL=index.js.map